import moment from 'moment'

export const API_URL = process.env.REACT_APP_API_URL

export const AWS_USER_POOL_ID = process.env.REACT_APP_AWS_USER_POOL_ID
export const AWS_USER_POOL_APP_CLIENT_ID = process.env.REACT_APP_AWS_USER_POOL_APP_CLIENT_ID

export const APP_VERSION = moment.unix(Number(process.env.REACT_APP_BUILD_DATE)).local().format('YYYY.MM.DD.HH.mm')
